import React, { useState } from "react";
import { Card, Form, Col } from "@deere/ux.uxframe-react";
import { Typography } from "@mui/material";
import { FILE_FORMAT_PDF } from "../../utils/surveyLiterals";
import { ERR_DOCUMENT_FORMAT } from "../../utils/errorLiterals";

const AttachmentUploads = ({ viewerQuestions, setAttachmentFiles }) => {
  const [error, setError] = useState(false);
  const uploadHandler = (e) => {
    setError(false);
    if (e.target.files.length > 0) {
      const file = e.target.files[0];
      const fileName = e.target.files[0].name;
      const extension = fileName.split(".")[fileName.split(".").length - 1];
      if (extension !== FILE_FORMAT_PDF) {
        e.target.value = null;
        setError(true);
      } else {
        const queId = e.target.name.split("_")[1];
        setAttachmentFiles((prevState) => {
          const newState = [...prevState];
          const index = newState.findIndex((file) => file.queId === queId);
          index > -1 ? (newState[index].file = file) : newState.push({ queId: queId, file: file });
          return newState;
        });
      }
    }
  };
  return (
    <Card>
      <Card.Body>
        <Typography className={"mt-2"} size="2x1" fontWeight={"semibold"} variant={"h2"}>
          Attachment Uploads
        </Typography>
        <Typography className={"mb-3"} fontWeight={"regular"} variant={"h3"}>
          Upload files for the File-Viewer type questions here.
        </Typography>
        {viewerQuestions &&
          viewerQuestions.length > 0 &&
          viewerQuestions.map((question) => (
            <Form.Row key={question.id}>
              <Form.Group as={Col} className="align-right">
                <Form.Label className="uxf-label">{question.text}</Form.Label>
                <Form.Control name={`queId_${question.id}`} onChange={uploadHandler} type="file" />
                {error && (
                  <Typography className="ml-2" variant="subtitle1" color="#C21020">
                    {ERR_DOCUMENT_FORMAT}
                  </Typography>
                )}
              </Form.Group>
            </Form.Row>
          ))}
      </Card.Body>
    </Card>
  );
};

export default AttachmentUploads;
